export function isResponseContainsKey<S extends object, E extends object>(response: S | E, key: string): response is S {
  return key in (response as S);
}
